/**
 * Application Constants
 * 
 * Constantes globales de la aplicación customer
 */

export const APP_CONFIG = {
  name: 'NextStore Customer Portal',
  version: '1.0.0',
  description: 'Portal de clientes para NextStore',
} as const

// Determinar la URL base de la API
// Prioridad: 1. VITE_API_URL (si está definida), 2. Fallback por MODE
const getApiBaseUrl = (): string => {
  let url: string

  // Si VITE_API_URL está definida, usarla (tiene prioridad absoluta)
  if (import.meta.env.VITE_API_URL) {
    url = import.meta.env.VITE_API_URL
  } else if (import.meta.env.MODE === 'production') {
    // Si estamos en producción (detectado por MODE)
    url = 'https://api.nextstore.ai/v1'
  } else {
    // Desarrollo por defecto
    url = 'https://yjfzdxyty7.execute-api.us-east-1.amazonaws.com/v1'
  }

  // Strip trailing slash to prevent double-slash in URL paths
  return url.replace(/\/+$/, '')
}

export const API_CONFIG = {
  baseUrl: getApiBaseUrl(),
  analyticsUrl: import.meta.env.VITE_ANALYTICS_API_URL || getApiBaseUrl(),
  timeout: 30000, // 30 segundos
} as const

export const FUNNELS_RUNTIME_CONFIG = {
  // Funnel runtime uses /v1/public/... paths, so the base must NOT include /v1.
  // VITE_FUNNELS_API_URL should be the root (e.g. https://api.trafiflow.com).
  // When falling back to API_CONFIG.baseUrl, strip its /v1 suffix to prevent double /v1.
  apiUrl: (import.meta.env.VITE_FUNNELS_API_URL || API_CONFIG.baseUrl.replace(/\/v1$/, '')).replace(/\/+$/, ''),
  tenantId: import.meta.env.VITE_FUNNELS_TENANT_ID || 'trafilea',
} as const

export const AUTH_CONFIG = {
  // En producción, estos valores DEBEN venir de variables de entorno
  // No usar valores por defecto en producción para evitar errores de autenticación
  userPoolId: import.meta.env.VITE_USER_POOL_ID || (import.meta.env.MODE === 'production' ? '' : 'us-east-1_yzGghXiH1'),
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || (import.meta.env.MODE === 'production' ? '' : '4eabp1p060ag3puv323nf7rlbl'),
  region: import.meta.env.VITE_REGION || 'us-east-1',
} as const






